export var MemberType;
(function (MemberType) {
    MemberType["Agent"] = "Agent";
    MemberType["User"] = "User";
})(MemberType || (MemberType = {}));
//# sourceMappingURL=member-type.const.js.map